import script from "./summary.vue?vue&type=script&lang=ts&setup=true"
export * from "./summary.vue?vue&type=script&lang=ts&setup=true"

import "./summary.vue?vue&type=style&index=0&id=5d790cdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d790cdc"]])

export default __exports__